import React, { useState } from 'react';

import PropTypes from 'prop-types';

import { DangerouslyHtml } from 'apps/auth/components/common/DangerouslyHtml/DangerouslyHtml';
import { InfoPage } from 'apps/auth/components/common/Layout/InfoPage/InfoPage';
import {
    LOW_RISK_UPGRADE_LIMIT_SCREEN,
    REACHING_LIMIT_SCREEN,
    UPGRADE_LIMIT_SCREEN,
    WAITING_SCREEN,
} from 'apps/auth/components/sharedComponents/status/Constants';
import PromoLowRiskUpgradeLimit from 'apps/auth/components/sharedComponents/status/PromoLowRiskUpgradeLimit';
import PromoReachingLimit from 'apps/auth/components/sharedComponents/status/PromoReachingLimit';
import PromoUpgradeLimit from 'apps/auth/components/sharedComponents/status/PromoUpgradeLimit';
import SendSMS from 'apps/auth/components/sharedComponents/status/SendSMS';
import { SMS_ON_SUCCESS_PAY_FORM_NAME } from 'apps/auth/constants/formName';
import { AUTH_MY_CARDS_URL, AUTH_PROFILE_INVITE, AUTH_SEND_MAIN_LINK } from 'apps/auth/constants/UrlConstants';
import { useExtra, usePageMessages } from 'apps/auth/hooks/selectors';

const Success = (props) => {
    const { headerTitle, statusText, statusSmsTitle, statusDoneTitle } = usePageMessages();
    const { cardPan, showLowRiskLimitIncrease } = useExtra();
    const [screen, setScreen] = useState(WAITING_SCREEN);

    const getPrimaryButtonLink = () => {
        if (props.status?.showUpgradeLimitPromo) {
            return '#';
        } else if (cardPan) {
            return AUTH_MY_CARDS_URL;
        } else if (props.status?.showInviteCodeReferralButton) {
            return AUTH_PROFILE_INVITE + '?showPromoSliders=true';
        } else {
            return AUTH_SEND_MAIN_LINK + '?screen_source=transfer_status';
        }
    };

    const primaryButtonOnClick = (e) => {
        if (showLowRiskLimitIncrease) {
            e.preventDefault();
            setScreen(LOW_RISK_UPGRADE_LIMIT_SCREEN);
        } else if (props.status?.showUpgradeLimitPromo) {
            e.preventDefault();
            setScreen(REACHING_LIMIT_SCREEN);
        }
    };

    // temporary switch off
    const isShowNotifyRecipient = false; //props.smsOnSuccessPay && !props.smsOnSuccessPay.sended && props.showSendSMSNotificationBlock;

    const renderScreen = (currentScreen) => {
        switch (currentScreen) {
            case REACHING_LIMIT_SCREEN:
                return <PromoReachingLimit primaryButtonOnClick={() => setScreen(UPGRADE_LIMIT_SCREEN)} />;
            case LOW_RISK_UPGRADE_LIMIT_SCREEN:
                return <PromoLowRiskUpgradeLimit modalRef={props.modalRef} />;
            case UPGRADE_LIMIT_SCREEN:
                return <PromoUpgradeLimit />;
            default:
                return (
                    <InfoPage
                        animatedIconSuccess
                        hasBorder={!!isShowNotifyRecipient}
                        headerText={headerTitle}
                        secondaryText={<DangerouslyHtml dangerouslyHtml={statusText} />}
                        buttonRowCaption={isShowNotifyRecipient ? statusSmsTitle : null}
                        buttonRowOnClick={() => props.modalRef.current.open(<SendSMS formName={SMS_ON_SUCCESS_PAY_FORM_NAME} />)}
                        primaryButtonCaption={statusDoneTitle}
                        primaryButtonType="link"
                        primaryButtonLink={getPrimaryButtonLink()}
                        primaryButtonOnClick={primaryButtonOnClick}
                    />
                );
        }
    };

    return renderScreen(screen);
};
Success.propTypes = {
    modalRef: PropTypes.object.isRequired,
    status: PropTypes.object.isRequired,
    smsOnSuccessPay: PropTypes.object,
    showSendSMSNotificationBlock: PropTypes.bool,
};

export default Success;
